import { render } from "./UserSignup.vue?vue&type=template&id=449552d7&scoped=true"
import script from "./UserSignup.vue?vue&type=script&lang=js"
export * from "./UserSignup.vue?vue&type=script&lang=js"

import "./UserSignup.vue?vue&type=style&index=0&id=449552d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449552d7"]])

export default __exports__